export default "__VITE_PUBLIC_ASSET__b24a6b37__"